// extracted by mini-css-extract-plugin
export default {"root":"ProductsView_root__FZEJn","panel":"ProductsView_panel__hIA+m","content":"ProductsView_content__8aKAO"};